import { useSelector } from "react-redux";
import { State } from "../../../store";
import { useEffect, useState } from "react";
import { GET_TICKET_BY_SHAPE } from "../../../api/apiRoutes";
import { get } from "../../../api";
import useFacility from "../../../../utils/hooks/useFacility";
import { Assort } from "../../../models/Assort";

export default function useBasketExtras() {
  const basketExtrasAssortGroupIds = useSelector(
    (state: State) => state.config.configuration.basketExtrasAssortGroupIds
  );
  const facilityIds = useFacility();
  const [extras, setExtras] = useState<Assort[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getShapeGroupByBasketExtrasAssortIds = async () => {
    setLoading(true);
    const { result, isError } = await get(GET_TICKET_BY_SHAPE(facilityIds, basketExtrasAssortGroupIds));
    if (!isError && Array.isArray(result)) {
      setExtras(result);
    } else {
      setExtras([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (basketExtrasAssortGroupIds) {
      getShapeGroupByBasketExtrasAssortIds();
    }
    //eslint-disable-next-line
  }, [basketExtrasAssortGroupIds]);

  return {
    extras,
    loading,
  };
}